import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '../../../controls/modal/modal.component';
import { sortBy } from '../../../shared/utils/sort-by';
import { CompanyLite } from '../../../shared/dto/company-lite';
import { CustomerManagementService } from '../../../data-services/customer-management.service';
import { UserService } from '../../../shared/services/user.service';
import { GrowlService } from '../../../shared/services/growl.service';
import { NgForm } from '@angular/forms';
import { touchForm } from '../../../shared/touch-form';
import { Router } from '@angular/router';
import { PatentPortfolioService } from '../../../patent-portfolio/patent-portfolio.service';

@Component({
  selector: 'townip-select-company-modal',
  templateUrl: './select-company-modal.component.html',
  styleUrls: ['./select-company-modal.component.scss']
})
export class SelectCompanyModalComponent implements OnInit {

  @ViewChild(ModalComponent, { static: true })
  public modal: ModalComponent;

  public companies: CompanyLite[];

  public selectedCompany: CompanyLite;

  constructor(
    private customerService: CustomerManagementService,
    private userService: UserService,
    private growlService: GrowlService,
    private router: Router,
    private patentPortfolio: PatentPortfolioService,
  ) {

  }

  public ngOnInit(): void { }

  public async show(): Promise<void> {
    await this.getCompanies();
    this.modal.show();
  }

  public async continue(form: NgForm): Promise<void> {
    touchForm(form);
    if (form.invalid) {
      return;
    }

    // It is important to clear this.
    // Org id and name can only be set here.
    this.patentPortfolio.clear();

    // Set when proper values has been selected
    this.patentPortfolio.organizationId = this.selectedCompany.id;
    this.patentPortfolio.organizationName = this.selectedCompany.companyName;

    // Note: REDIRECT TO PATENT PORTFOLIO.
    // Do not redirect directly to overview. Routs + guard handle themselves.
    const route = { route: 'patent-portfolio' };
    this.router.navigate(['redirect'], { queryParams: route });
  }

  public cancel(): void {
    this.modal.hide();
  }

  public clear(): void {
    this.companies = [];
    this.selectedCompany = null;
  }

  private async getCompanies(): Promise<void> {
    const companies = await this.customerService
      .getCompanyLitesByUserIdAndCompanyService(this.userService.getUser().id, 'ANNUITIES')
      .toPromise();

    this.companies = sortBy(
      companies,
      (company: CompanyLite) => {
        return company
          .companyName
          .toUpperCase();
      });
  }

}
